import { Button } from 'antd'
import { HistoryOutlined } from '@ant-design/icons'
import { Can } from '@kolab/dms-base/rbac'
import type { Device } from '../../../types/device.types'
import type { DeviceActionsRef } from '../DeviceActions'
import DeviceMap from '../../map/DeviceMap'
import { formatDate } from '../../../utils/formatters'
import { P } from '../../../rbac'

interface MapAndActionsViewProps {
  device: Device
  actionsRef: React.RefObject<DeviceActionsRef | null>
}

export default function MapAndActionsView({ device, actionsRef }: MapAndActionsViewProps) {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <DeviceMap device={device} />

      {/* Location info popup */}
      {device.geolocation && (
        <div
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            zIndex: 10,
            background: '#fff',
            borderRadius: 12,
            padding: '16px 20px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
            maxWidth: 'min(320px, calc(100% - 32px))',
          }}
        >
          <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1e293b', margin: '0 0 8px' }}>
            Approximate location
          </h3>
          <p style={{ fontSize: 13, color: '#475569', margin: '0 0 4px' }}>
            Lat: {device.geolocation.lat}, Lon: {device.geolocation.lon}
          </p>
          {device.lastPingAt && (
            <p style={{ fontSize: 13, color: '#475569', margin: '0 0 4px' }}>
              <strong>Obtained on</strong> {formatDate(device.lastPingAt)}
            </p>
          )}
          <p style={{ fontSize: 13, color: '#475569', margin: '0 0 16px' }}>Accuracy: --</p>

          <div style={{ display: 'flex', gap: 8 }}>
            <Button icon={<HistoryOutlined />} style={{ borderRadius: 8 }} disabled>
              Location history
            </Button>
          </div>
        </div>
      )}

      {/* Action buttons floating bar */}
      <div
        style={{
          position: 'absolute',
          bottom: 16,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 8,
          background: 'rgba(255, 255, 255, 0.92)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          borderRadius: 12,
          padding: '8px 16px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.6)',
          maxWidth: 'calc(100% - 32px)',
        }}
      >
        <Can permission={P.device_operations.device.lock}>
          <Button
            type="primary"
            danger
            onClick={() => actionsRef.current?.openLock()}
            style={{ borderRadius: 8 }}
          >
            Lock
          </Button>
        </Can>
        <Can permission={P.device_operations.device.unlock}>
          <Button
            onClick={() => actionsRef.current?.openUnlock()}
            style={{
              borderRadius: 8,
              color: device.isOnline ? '#10b981' : undefined,
              borderColor: device.isOnline ? '#10b981' : undefined,
            }}
          >
            Unlock
          </Button>
        </Can>
        <Can permission={P.device_operations.device.notify}>
          <Button onClick={() => actionsRef.current?.openMessage()} style={{ borderRadius: 8 }}>
            Send Message
          </Button>
        </Can>
      </div>
    </div>
  )
}
